import React, { useState, useEffect } from 'react';
import { css } from '@emotion/core';
import { Observer } from 'mobx-react';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Divider,
  Checkbox,
  ListItemIcon,
  Collapse,
  Tooltip,
  ListItemSecondaryAction,
  IconButton,
} from '@material-ui/core';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import { Link } from 'react-router-dom';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { toJS } from 'mobx';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Spinner from '../../util/Spinner';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv, WideBox } from '../../styles/styles';
import { COLORS } from '../../util/Colors';

const Container = css`
  max-width: 1200px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
`;

const ChecklistSection = ({ title, dataArray }) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(!open);
  };

  const handleLink = (category, item) => {
    let route = '';

    switch (category) {
      case 'Account':
        route = {
          pathname: `/accounts/new`,
          search: item,
          state: { fromChecklist: true },
        };
        break;

      case 'Transaction Categories':
        route = {
          pathname: `/transaction-categories/new`,
          search: item,
          state: { fromChecklist: true },
        };
        break;

      default:
        route = '/onboarding/checklist';
    }
    return route;
  };

  const tooltipDesc = cat => {
    if (cat === 'Account') {
      return 'Financial Accounts required to create transactions';
    }
    if (cat === 'Transaction Categories') {
      return 'At least one receivable and payable transaction category is required';
    }
  };

  return (
    <List style={{ width: 'inherit' }}>
      <ListItem onClick={handleClick}>
        <ListItemText
          primary={
            <div>
              {title} ({dataArray.filter(item => item.IsOk).length}/
              {dataArray.length}){' '}
              <Tooltip title={tooltipDesc(title)} placement="right">
                <HelpOutlineIcon
                  style={{ color: COLORS.blue }}
                  fontSize="inherit"
                />
              </Tooltip>
            </div>
          }
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {dataArray.map((task, index) => (
          <ListItem divider={index !== dataArray.length - 1} key={task.Item}>
            <ListItemIcon>
              <Checkbox disabled size="small" checked={Boolean(task.IsOk)} />
            </ListItemIcon>
            <ListItemText inset primary={task.Item} />
            <ListItemSecondaryAction>
              <Link to={handleLink(title, task.Item)}>
                <IconButton>
                  <ChevronRightIcon />
                </IconButton>
              </Link>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </Collapse>
    </List>
  );
};
function Checklist() {
  return (
    <Observer
      render={() => {
        const [tasks, setTasks] = useState(null);
        const { orgStore } = useRootStore();
        const { setupTasks } = orgStore;
        const setupComplete = orgStore.setupStatus;

        useEffect(() => {
          orgStore.retrieveChecklist();
        }, []);

        useEffect(() => {
          if (setupTasks) {
            setTasks(setupTasks);
          }
        }, [tasks, setupTasks]);

        if (!tasks) return null;

        if (setupTasks && !setupComplete) {
          return (
            <Grid item lg={12} xs={12} style={{ marginTop: '1rem' }}>
              <Card style={{ height: '100%' }}>
                <CardHeader
                  title={
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      {' '}
                      <PriorityHighIcon
                        fontSize="small"
                        style={{ color: COLORS.orange }}
                      />{' '}
                      Setup Checklist{' '}
                    </span>
                  }
                  subheader={
                    <span style={{ marginLeft: '15px' }}>
                      Please address the items listed below to complete setup
                    </span>
                  }
                />
                <Divider />
                <CardContent style={{ padding: '0 12px' }}>
                  <List>
                    {tasks.map((section, index) => {
                      const { Category, Items } = section;
                      return (
                        <ListItem
                          key={Category}
                          divider={index !== tasks.length - 1}
                        >
                          <ChecklistSection
                            title={Category}
                            dataArray={Items}
                          />
                        </ListItem>
                      );
                    })}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          );
        }
        return null;
      }}
    />
  );
}

export default Checklist;
